<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        small
        icon
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Perquisite"
      text="Update Perquisite"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="localPerquisite.benefit_in_kind_id"
              v-validate="'required'"
              :items="benefitInKinds"
              item-text="name"
              item-value="id"
              label="Perquisites"
              :error-messages="errors.collect('benefit_in_kind_id')"
              data-vv-name="benefit_in_kind_id"  
              data-vv-as="perquisite"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="localPerquisite.tax_exemption_id"
              :items="taxExemptions"
              item-text="name"
              item-value="id"
              label="Tax Exemption"
              data-vv-as="taxExemption"
              outlined
            />
          </v-col>
          
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localPerquisite.amount"
              v-money="money"
              label="Amount"
              prefix="RM"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDateDisplay"
                  v-validate="'required'"
                  :error-messages="errors.collect('startDateDisplay')"
                  data-vv-name="startDateDisplay"
                  data-vv-as="start date"
                  label="Start date"
                  readonly
                  outlined
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localPerquisite.start_date"
                no-title
                :min="companyEmployeeStartDate"
                @input="startDateMenu = false"
              />
            </v-menu> 
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"
          class="px-10 white--text"
          :loading="progressing"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      perquisite: {
        type: Object,
        default: null,
        required: true,
      },
      companyEmployeeStartDate: {
        type: String,
        required: true,
      },
    },

    data () {
      return {
        dialog: false,
        progressing: false,
        startDateMenu: false,
        endDateMenu: false,
        localPerquisite: null,
        benefitInKinds: [],
        taxExemptions: [],
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
        yearFilter: parseInt(this.$moment().format('YYYY')),
      }
    },

    computed: {
      startDateDisplay () {
        return this.localPerquisite.start_date ? this.$moment(this.localPerquisite.start_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },

    watch: {
      dialog: function (val) {
        if (!val) return
        
        this.localPerquisite = { ...this.perquisite }
        if (this.localPerquisite.amount) this.localPerquisite.amount = (Math.round((this.localPerquisite.amount / 100) * 100) / 100).toFixed(2)

        Promise.all([
          this.$api.benefitInKinds().list('?filter[type]=perquisite'),
          this.$api.taxExemptions().list({ year: this.yearFilter }),
        ])
          .then(([perquisite, taxExemption]) => {
            this.benefitInKinds = _.orderBy(perquisite.data, ['name'], ['asc'])
            this.taxExemptions = _.orderBy(taxExemption.data, ['name'], ['asc'])

            this.loading = false
          })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            
            this.$api.companyEmployeePerquisites().update(this.localPerquisite.id, this.prepareFormData())
              .then(res => {
                this.$emit('updated')
                this.$snack({ message: res.data.status })

                this.dialog = false
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return { 
          start_date: this.localPerquisite.start_date,
          benefit_in_kind_id: this.localPerquisite.benefit_in_kind_id,
          tax_exemption_id: this.localPerquisite.tax_exemption_id,
          end_date: this.localPerquisite.start_date,
          amount: this.localPerquisite.amount.toString().replaceAll(',', '') * 100,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
